module.exports = __webpack_public_path__ + "static/media/Waves.8b13da40.gif";